import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { baseAttachDto, SingleResponseModel } from '../../models/base/base';

@Injectable({
  providedIn: 'root'
})
export class BaseAttachService {
  private baseUrl = environment.baseUrl + 'TABAttachements';

  constructor(private http: HttpClient) { }

  // create(formData, fileName, recordId, menuKey, pageParameter): Observable<HttpEvent<SingleResponseModel<baseAttachDto>>> {
  //   let queryParams = {
  //     'description': fileName,
  //     '_menukey': menuKey
  //   }
  //   // console.log("pageParameter", pageParameter);

  // if (pageParameter != null && pageParameter != "null") {
  //   //debugger
  //       queryParams['_pageparameter'] = pageParameter;
  //   }
  //   if (recordId) queryParams['recordid'] = recordId
  //   let httpParams = new HttpParams({ fromObject: queryParams });


  //   return this.http.post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/SaveFile`, formData,
  //     {
  //       params: httpParams,
  //       reportProgress: true, observe: 'events'
  //     }
  //   );
  // }

  // SaveProfilePic(formData, fileName, recordId, menuKey, pageParameter): Promise<HttpEvent<SingleResponseModel<baseAttachDto>>> {
  //   let queryParams;
  //   queryParams = `Description=${fileName}&_menuKey=${menuKey}&_pageparameter=${pageParameter}&UserId=${recordId}`;

  //   return this.http
  //     .post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/SaveProfilePic?${queryParams}`, formData, {
  //       reportProgress: true,
  //       observe: 'events'
  //     })
  //     .toPromise();
  //   //return this.http.post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/Create`, data);
  // }

  UpdateProfilePic(formData, attachId, userId, fileName): Observable<HttpEvent<SingleResponseModel<baseAttachDto>>> {
    let queryParams = `attachid=${attachId}&userid=${userId}&description=${fileName}`;
    return this.http
      .post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/UpdateProfilePic?${queryParams}`, formData, {
        reportProgress: true,
        observe: 'events'
      })
  }

  // update(id: any, data: baseAttachDto): Observable<SingleResponseModel<baseAttachDto>> {
  //   return this.http.put<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/Update`, data);
  // }

  // delete(fileId: any, fileRelativePath): Observable<any> {
  //   return this.http.delete(`${this.baseUrl}/DeleteFile?fileRelativePath=${fileRelativePath}&fileid=${fileId}`);
  // }

  deleteFile(fileId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/DeleteFile?fileid=${fileId}`, {});
  }
  // getbyParam(path: string, params: any): Observable<SingleResponseModel<baseAttachDto>> {
  //   // returns single record
  //   return this.http.get<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/${path}`, { params: params });
  // }

  GetFileData(menukey, pageparameter, recordId): Observable<SingleResponseModel<baseAttachDto[]>> {
    // returns Array
    let params
    if (pageparameter == null || pageparameter == "null") params = { menukey, recordid: recordId };
    else params = { menukey, pageparameter, recordid: recordId };
    return this.http.get<SingleResponseModel<baseAttachDto[]>>(`${this.baseUrl}/${'GetFileData'}`, { params: params });
  }

  GetFileDataWithStream(menukey, pageParameter, recordId): Observable<SingleResponseModel<baseAttachDto[]>> {
    // returns Array
    let params
    if (pageParameter == null || pageParameter == "null") params = { _menukey: menukey, recordid: recordId };
    else params = { _menukey: menukey, _pageparameter: pageParameter, recordid: recordId };
    return this.http.get<SingleResponseModel<baseAttachDto[]>>(`${this.baseUrl}/${'GetFileDataWithStream'}`, { params: params });
  }
  DeleteBulkFile(menukey, pageParameter, recordId): Observable<SingleResponseModel<baseAttachDto>> {
    let params
    if (pageParameter == null || pageParameter == "null") params = { menukey: menukey, recordid: recordId };
    else params = { menukey: menukey, pageparameter: pageParameter, recordid: recordId };
    const httpParams = new HttpParams({ fromObject: params });
    return this.http.post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/DeleteBulkFile`, {}, { params: httpParams });
  }
  create(formData, fileName, recordId, menuKey, pageParameter, folderNumber = 1): Observable<HttpEvent<SingleResponseModel<baseAttachDto>>> {
    let queryParams = {
      'description': fileName,
      '_menukey': menuKey,
      'foldernumber' : folderNumber
    }
    // console.log("pageParameter", pageParameter);

    if (pageParameter != null && pageParameter != "null") {
      //debugger
      queryParams['_pageparameter'] = pageParameter;
    }
    if (recordId) queryParams['recordid'] = recordId
    let httpParams = new HttpParams({ fromObject: queryParams });
    console.log("fileName", fileName);
    
    console.log("queryParams", queryParams);
    console.log("httpParams", httpParams);
    
    
    return this.http.post<SingleResponseModel<baseAttachDto>>(`${this.baseUrl}/GenaricAttachByNumber`, formData,
      {
        params: httpParams,
        reportProgress: true, 
        observe: 'events'
        // observe: 'body'
      }
    );
  }
}
